import Duck from 'extensible-duck';
import Immutable from 'immutable';
import forEach from 'lodash/forEach';
import { arrayMove } from 'react-sortable-hoc';

import requestsManagerAxios from '../../lib/requestsManagerAxios';

export default new Duck({
  namespace: 'public',
  store: 'sponsor',
  types: [
    'MOVE_SPONSOR',
    'CREATE_SPONSOR',
    'CREATE_SPONSOR_PENDING',
    'CREATE_SPONSOR_FULFILLED',
    'CREATE_SPONSOR_REJECTED',
    'DELETE_SPONSOR',
    'DELETE_SPONSOR_PENDING',
    'DELETE_SPONSOR_FULFILLED',
    'DELETE_SPONSOR_REJECTED',
    'UPDATE_SPONSOR',
    'UPDATE_SPONSOR_PENDING',
    'UPDATE_SPONSOR_FULFILLED',
    'UPDATE_SPONSOR_REJECTED',
    'UPDATE_SPONSOR_POSITION',
    'UPDATE_SPONSOR_POSITION_PENDING',
    'UPDATE_SPONSOR_POSITION_FULFILLED',
    'UPDATE_SPONSOR_POSITION_REJECTED',
  ],
  initialState: Immutable.fromJS({
    $$sponsors: [],
  }),
  reducer: ($$state, { type, payload, meta }, { types }) => {
    switch (type) {
      case types.CREATE_SPONSOR_FULFILLED:
        return $$state.update('$$sponsors', $$sponsors =>
          $$sponsors.push(Immutable.fromJS(payload.data))
        );
      case types.DELETE_SPONSOR_FULFILLED:
        return $$state.update('$$sponsors', $$sponsors =>
          $$sponsors.filterNot(
            $$sponsor => $$sponsor.get('id') === meta.sponsorId
          )
        );
      case types.MOVE_SPONSOR:
        return $$state.update('$$sponsors', $$sponsors =>
          Immutable.fromJS(
            arrayMove($$sponsors.toJS(), payload.oldIndex, payload.newIndex)
          )
        );
      case types.MOVE_SPONSOR_BACK:
      case types.UPDATE_SPONSOR_FULFILLED: {
        const index = $$state
          .get('$$sponsors')
          .findIndex($$sponsor => $$sponsor.get('id') === meta.sponsorId);
        return $$state.setIn(
          ['$$sponsors', index],
          Immutable.fromJS(payload.data)
        );
      }
      case types.UPDATE_SPONSOR_POSITION_FULFILLED:
        return $$state.set('$$sponsors', Immutable.fromJS(payload.data));
      case types.UPDATE_SPONSOR_POSITION_REJECTED:
        return $$state.update('$$sponsors', $$sponsors =>
          Immutable.fromJS(
            arrayMove($$sponsors.toJS(), meta.newIndex, meta.oldIndex)
          )
        );
      default:
        return $$state;
    }
  },
  selectors: {},
  creators: ({ types }) => ({
    createSponsor: sponsor => {
      const data = new FormData();
      forEach(sponsor, (value, key) => data.append(`sponsor[${key}]`, value));
      return {
        type: types.CREATE_SPONSOR,
        payload: requestsManagerAxios.post('/admin/sponsors', data),
      };
    },
    deleteSponsor: sponsorId => ({
      type: types.DELETE_SPONSOR,
      payload: requestsManagerAxios.delete(`/admin/sponsors/${sponsorId}`),
      meta: { sponsorId },
    }),
    moveSponsorAndSave: (oldIndex, newIndex) => (dispatch, getState) => {
      const { $$sponsorStore } = getState();
      const sponsorId = $$sponsorStore.getIn(['$$sponsors', oldIndex, 'id']);
      dispatch({
        type: types.MOVE_SPONSOR,
        payload: { oldIndex, newIndex },
      });
      return dispatch({
        type: types.UPDATE_SPONSOR_POSITION,
        payload: requestsManagerAxios.post(
          `/admin/sponsors/${sponsorId}/move`,
          { sponsor: { position: newIndex + 1 } }
        ),
        meta: { oldIndex, newIndex },
      });
    },
    updateSponsor: sponsor => {
      const data = new FormData();
      forEach(sponsor, (value, key) => data.append(`sponsor[${key}]`, value));
      return {
        type: types.UPDATE_SPONSOR,
        payload: requestsManagerAxios.patch(
          `/admin/sponsors/${sponsor.id}`,
          data
        ),
        meta: { sponsorId: sponsor.id },
      };
    },
  }),
});
